import { generateUUID } from '@lumapps/utils/string/generateUUID';

(function IIFE() {
    'use strict';

    /////////////////////////////

    function DirectoryTagAdminController($scope, $stateParams, $timeout, ConfigTheme, DataTable, Directory,
        FormValidation, LxDialogService, LxNotificationService, Translation, Utils) {
        'ngInject';

        var vm = this;

        /////////////////////////////
        //                         //
        //    Public attributes    //
        //                         //
        /////////////////////////////

        /**
         * Tag dialog element key.
         *
         * @type {string}
         * @constant
         * @readonly
         */
        vm.TAG_DIALOG_KEY = 'tag-dialog-key';

        /**
         * Contains the tag we are currently adding/editing.
         *
         * @type {Object}
         */
        vm.currentTag = undefined;

        /**
         * Contains the directory tag settings form.
         *
         * @type {Object}
         */
        vm.directoryTagSettingsForm = {};

        /////////////////////////////

        /**
         * Services and utilities.
         */
        vm.ConfigTheme = ConfigTheme;
        vm.DataTable = DataTable;
        vm.Directory = Directory;
        vm.FormValidation = FormValidation;
        vm.Translation = Translation;

        /////////////////////////////
        //                         //
        //     Public functions    //
        //                         //
        /////////////////////////////

        /**
         * Open the tag setting dialog for tag creation.
         */
        function addTag() {
            vm.currentTag = {
                name: {},
                uuid: generateUUID(),
            };
            Utils.waitForAndExecute('#' + vm.TAG_DIALOG_KEY);
        }

        /**
         * Display a lumx dialog to confirm deletion of selected items.
         */
        function deleteSelectedItems() {
            LxNotificationService.confirm(
                Translation.translate('ADMIN_DELETE_SELECTED_ITEMS'),
                Translation.translate('ADMIN_DELETE_SELECTED_ITEMS_DESCRIPTION'), {
                    cancel: Translation.translate('GLOBAL.CANCEL'),
                    ok: Translation.translate('GLOBAL.OK'),
                }, function onDeleteDirectoryTagConfirmationSuccess(answer) {
                    if (!answer) {
                        return;
                    }

                    Directory.getCurrent().tags = DataTable.getNonSelectedItems();

                    Directory.save(Directory.getCurrent(), function onDirectorySaveSuccess() {
                        DataTable.refresh(Directory.getCurrent().tags);
                        // Refresh local directory list.
                        Directory.updateLocalList(Directory.getCurrent());

                        LxNotificationService.success(Translation.translate('ADMIN_DELETE_SELECTED_ITEMS_SUCCESS'));
                    }, Utils.displayServerError);
                });
        }

        /**
         * Open hydrated setting dialog with selected item.
         */
        function editTag() {
            // find the first selected tag.
            var tag = DataTable.getFirstSelectedItem();

            if (angular.isDefinedAndFilled(tag)) {
                // Set tag to current for edition.
                vm.currentTag = angular.fastCopy(tag);
                Utils.waitForAndExecute('#' + vm.TAG_DIALOG_KEY);
            }
        }

        /**
         * Register a form so we can reference it easily.
         *
         * @param {Object} scope The form scope.
         */
        function registerForm(scope) {
            $timeout(function registerFormTimeout() {
                vm.directoryTagSettingsForm = _.get(scope, 'directoryTagSettingsForm');
            });
        }

        /**
         * Save the tag we are currently adding/editing.
         */
        function saveTag() {
            var currentDirectory = Directory.getCurrent();

            if (vm.directoryTagSettingsForm.$invalid || Utils.isLangArrayEmpty(vm.currentTag.name)) {
                FormValidation.setFormDirty(vm.directoryTagSettingsForm);
                LxNotificationService.error(Translation.translate('ERROR_MANDATORY_FIELDS'));

                return;
            }

            // Search if tag exist.
            var tag = _.find(currentDirectory.tags, function checkUuid(item) {
                return item.uuid === vm.currentTag.uuid;
            });

            // If tag is set, update else create it.
            if (angular.isDefinedAndFilled(tag)) {
                tag.name = vm.currentTag.name;
            } else {
                currentDirectory.tags = currentDirectory.tags || [];
                currentDirectory.tags.push(vm.currentTag);
            }

            // Save tag to current directory.
            Directory.save(currentDirectory, function onDirectorySaveSuccess() {
                currentDirectory = Directory.getCurrent();

                // Need to be refresh because in this particular case we lose reference of Directory.getCurrent().
                DataTable.refresh(currentDirectory.tags);
                // Refresh local directory list.
                Directory.updateLocalList(currentDirectory);
                LxDialogService.close(vm.TAG_DIALOG_KEY);
            }, Utils.displayServerError);
        }

        /////////////////////////////

        vm.addTag = addTag;
        vm.deleteSelectedItems = deleteSelectedItems;
        vm.editTag = editTag;
        vm.registerForm = registerForm;
        vm.saveTag = saveTag;

        /////////////////////////////
        //                         //
        //          Events         //
        //                         //
        /////////////////////////////

        /**
         * When the controller is destroyed, destroy the datable too.
         */
        $scope.$on('$destroy', DataTable.destroy);

        /**
         * Watch dialog close to reset current item.
         *
         * @param {Event}  evt      The dialog close event.
         * @param {string} dialogId The id of the dialog that closes.
         */
        $scope.$on('lx-dialog__close-end', function onLxDialogClose(evt, dialogId) {
            if (dialogId === vm.TAG_DIALOG_KEY) {
                vm.currentTag = undefined;
            }
        });

        /**
         * Watch input language changes to reset form pristine.
         */
        $scope.$on('inputLanguage', function onInputLanguageChange() {
            if (angular.isDefined(vm.directoryTagSettingsForm)) {
                vm.directoryTagSettingsForm.$setPristine();
            }
        });

        /////////////////////////////

        /**
         * Initialize the controller.
         */
        function init() {
            // Get the wanted directory to access it with Directory.getCurrent().
            Directory.get({
                uid: $stateParams.id,
            }, function onDirectoryGetSuccess() {
                // Set a reference of the tags to the data table, that allow us to do some action.
                DataTable.init(function initDataTable() {
                    return _.get(Directory.getCurrent(), 'tags', []);
                }, 'uuid');
            });
        }

        init();
    }

    angular.module('Controllers').controller('DirectoryTagAdminController', DirectoryTagAdminController);
})();
